import { Badge, type BadgeVariant } from '@/components/ui/badge'
import { RunStatus } from '@/models/agentRunReport'

const STATUS: Partial<Record<RunStatus, { label: string; variant: BadgeVariant }>> = {
  [RunStatus.SUCCESS]: { label: 'Succeeded', variant: 'success' },
  [RunStatus.ERROR]: { label: 'Failed', variant: 'destructive' },
  // A user pressing Stop is stored as an ERROR row but isn't a failure.
  [RunStatus.CANCELLED]: { label: 'Cancelled', variant: 'outline' },
}

const FALLBACK = { label: 'Failed', variant: 'destructive' } as const

export function StatusBadge({ status }: { status: RunStatus }) {
  const config = STATUS[status] ?? FALLBACK
  return <Badge variant={config.variant}>{config.label}</Badge>
}
